export default __webpack_public_path__ + "static/media/Lateral_Left_Male_.0c046871.png";